var render = function render(){var _vm=this,_c=_vm._self._c;return _c('examples-block',{attrs:{"gitUrl":"src/components/examples/BreadCrumbs/BreadCrumbsIcons.vue","title":"Хлебные крошки с иконками"}},[_c('div',{staticStyle:{"width":"300px"}},[_c('r-bread-crumbs',{attrs:{"items":_vm.items}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }